import AbstractRuleTemplateModel from "./AbstractRuleTemplateModel.js";

/**
 * RuleTemplateModel to use when the ruleTemplate is inherited.
 * It holds 2 ruleTemplate. One that is inherited and that is "read-only",
 * and a fresh one to override data. It makes sure the fresh one has the same
 * value as the inherited one for a better user experience.
 *
 * @param {AbstractForecastReport} report - Report used to retrieve
 *   the inherited row and column
 * @param {RuleTemplate} inheritedRuleTemplate - The rule that we inherit from
 */
export default class InheritRuleTemplateModel extends AbstractRuleTemplateModel {
	constructor({ report, inheritedRuleTemplate }) {
		super(...arguments);
		this._report = report;
		this._inheritedRow = undefined;
		this._inheritedColumn = undefined;

		this._ruleTemplate.setRuleModel(
			inheritedRuleTemplate.getRuleModel().clone(),
		);

		this._inheritedRuleTemplate = inheritedRuleTemplate;
		this._updateInheritedRowAndColumn({ inheritedRuleTemplate });
	}

	getInheritedRow() {
		return this._inheritedRow;
	}

	getInheritedColumn() {
		return this._inheritedColumn;
	}

	isInheritedRule() {
		return true;
	}

	ruleTemplateWidgetContentRenderer(ruleTemplateWidget) {
		return (html) => ruleTemplateWidget.renderInheritedRuleTemplateOn(html);
	}

	ruleTemplateDescriptionWidgetRenderer(ruleTemplateWidget) {
		return (html) =>
			ruleTemplateWidget.renderRuleTemplateDescriptionOn(html);
	}

	_updateInheritedRowAndColumn({ inheritedRuleTemplate }) {
		if (!this._report) return;

		this._inheritedRow = this._report.getRowByStableId(
			inheritedRuleTemplate.getRowId(),
		);

		this._inheritedColumn = this._report.getColumnMatching((col) =>
			col.getStart().equal(inheritedRuleTemplate.getStart()),
		);
	}

	_makeDeleteActionOn(ruleTemplatesWidget) {
		return ruleTemplatesWidget.makeNullRuleTemplateAction(
			this._ruleTemplate,
		);
	}

	_makeSaveActionOn(ruleTemplatesWidget) {
		return ruleTemplatesWidget.makeAddRuleTemplateAction(
			this._ruleTemplate,
		);
	}

	_hasRuleModelChanged() {
		const inheritedRuleSerialization =
			this._getSerializedInheritedRuleModel();
		const currentSerialization = this._getSerializedRuleModel();

		return (
			JSON.stringify(inheritedRuleSerialization) !==
			JSON.stringify(currentSerialization)
		);
	}

	_getSerializedInheritedRuleModel() {
		return this._inheritedRuleTemplate?.getRuleModel().serialize();
	}
}
